// Lane F — small badge that shows the GMP number issued to a record (numbering ledger, GET /bp/numbering/lookup/).
//   <GmpNumber objectType="TicketDetails" objectRef={ticket.id} />            -> DEV-AHM-26-0007
//   <GmpNumber objectType="MachineCleaning" objectRef={row.id} kind="CLEANING" />
//   <GmpNumber objectType="InspectionSession" objectRef={sessionId} />  (lot board) · objectType="UnitContainer" for a tub
// `number` short-circuits the lookup when the payload already carries it (ticket list/detail expose `gmp_number`).
import React, { useEffect, useState } from 'react';
import { Tag, Tooltip } from 'antd';
import { Hash } from 'lucide-react';
import { lookup_gmp_number } from '@/utils/numbering_api';

const cache = new Map();

const GmpNumber = ({ objectType, objectRef, kind, number, size = 'small', showEmpty = false, style }) => {
  const [value, setValue] = useState(number ? { number, is_void: false, kind: kind || '' } : null);

  useEffect(() => {
    if (number || !objectType || objectRef === undefined || objectRef === null || objectRef === '') return undefined;
    const key = `${objectType}:${objectRef}:${kind || ''}`;
    if (cache.has(key)) {
      setValue(cache.get(key));
      return undefined;
    }
    let cancelled = false;
    lookup_gmp_number(objectType, String(objectRef), kind).then((res) => {
      if (cancelled) return;
      const data = res?.status === 'success' ? res.data : { number: '', is_void: false, kind: '' };
      cache.set(key, data);
      setValue(data);
    });
    return () => {
      cancelled = true;
    };
  }, [objectType, objectRef, kind, number]);

  if (!value || !value.number) {
    return showEmpty ? (
      <Tag style={{ fontFamily: 'monospace', ...style }}>—</Tag>
    ) : null;
  }
  const label = value.kind ? `${value.kind} number` : 'GMP number';
  return (
    <Tooltip title={value.is_void ? `${label} (VOID)` : label}>
      <Tag
        color={value.is_void ? 'red' : 'geekblue'}
        icon={<Hash size={size === 'small' ? 11 : 13} style={{ marginRight: 2, verticalAlign: -1 }} />}
        style={{ fontFamily: 'monospace', textDecoration: value.is_void ? 'line-through' : 'none', ...style }}
      >
        {value.number}
      </Tag>
    </Tooltip>
  );
};

export default GmpNumber;
